module.exports = __webpack_public_path__ + "img/DE05685.8ed65ed8.png";